import React, { useState, useEffect } from 'react';
import "./Home.css";
import { getStoredData } from '../../JsonFiles/fetchData';
import IntroVideo from "../../components/IntroVideo/IntroVideo";
import QuickLinks from "../../components/QuickLinks/QuickLinks";
import HomeAboutSection from "../../components/HomeAboutSection/HomeAboutSection";
import HeroIntro from '../../components/ProductList/HeroIntro';
import AllTestimonial from "../../components/AllTestimonials/AllTestimonial";
import NewsShorts from "../../components/NewsShorts/NewsShorts";
import RedirectToPage from "../../components/RedirectToPage/RedirectToPage";
import axios from 'axios';

const Home = () => {
  const data = getStoredData()?.["3"] ?? {};
  const [products, setProducts] = useState([]);
  const [services, setServices] = useState([]);
  const [news, setNews] = useState([]);

  useEffect(() => {
    // Fetch products
    axios.get('https://shahbad-enterprises-backend.vercel.app/products')
      .then(response => setProducts(response.data))
      .catch(error => console.error('Error fetching products:', error));

    // Fetch services
    axios.get('https://shahbad-enterprises-backend.vercel.app/services')
      .then(response => setServices(response.data))
      .catch(error => console.error('Error fetching services:', error));

    // Fetch news
    axios.get('https://shahbad-enterprises-backend.vercel.app/news')
      .then(response => setNews(response.data))
      .catch(error => console.error('Error fetching news:', error));
  }, []);

  return (
    <div className='home-container'>
      <IntroVideo title={data.introTitle} links={data.introLinks} image={data.introImage} />
      <QuickLinks links={data.QuickLinks} Title={data.QuickLinksTitle} />
      <HomeAboutSection
        link={data.AboutLink}
        title={data.AboutTitle}
        details={data.AboutDetails}
        buttonText={data.AboutButton}
        images={data.AboutImages}
      />
      {/* <ProductList products={products} services={services}/> */}
      <HeroIntro products={products} services={services} data={data}/>
      {/* <ServicesList services={services} /> */}
      <AllTestimonial data={data}/>
      <RedirectToPage 
        link={data.RedirectLink} 
        title={data.RedirectTitle} 
        image={data.RedirectImage} 
        details={data.RedirectDetails} 
        ButtonText={data.RedirectButtonText}
      />
      <NewsShorts news={news} data={data}/>
    </div>
  );
};

export default Home;

